// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__eSNU3","wrapper":"checkbox_wrapper__10Cq3","label":"checkbox_label__3Khwr"};